import { useEffect, useState } from 'react';

import { dispatchSlideChange } from '../trackings';

export const useGalleryActiveSlide = (
  defaultActiveItem: number,
  listLength: number,
  productGalleryV2?: boolean
) => {
  const [activeSlide, setActiveSlide] = useState({
    index: defaultActiveItem,
    origin: null,
  });

  const setActiveItem = (origin: string) => (index: number) => {
    setActiveSlide({ index, origin });
  };

  useEffect(() => {
    if (activeSlide.origin && !productGalleryV2) {
      dispatchSlideChange({
        element: activeSlide.origin,
        index: activeSlide.index,
        listLength,
      });
    }
  }, [activeSlide.index, productGalleryV2]);

  return [activeSlide.index, setActiveItem] as const;
};
